import { useForm } from "@inertiajs/react"
import { AdminPromotion } from "@/types/serializers"
import Button from "./Button"
import Input from "./Input"

const PromotionManagers = ({ promotion }: { promotion: AdminPromotion }) => {
  const { id, managers } = promotion

  const { data, setData, post, processing, errors, resetAndClearErrors } =
    useForm({
      email: "",
    })

  const handleAddManager = async (e: React.FormEvent) => {
    e.preventDefault()

    post(`/admin/promotions/${id}/managers`, {
      async: true,
      preserveScroll: true,
      onSuccess: () => resetAndClearErrors(),
    })
  }

  const { delete: destroy, processing: isRemoving } = useForm()

  const handleRemoveManager = (userId: string) => {
    const confirmation = confirm(
      "Are you sure you want to remove this manager?"
    )

    if (!confirmation) return

    destroy(`/admin/promotions/${id}/managers/${userId}`, {
      async: true,
      preserveScroll: true,
      preserveState: true,
    })
  }

  return (
    <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-4">
      <h4 className="text-base font-semibold text-gray-900">Managers</h4>

      {managers && managers.length > 0 ? (
        <ul className="mt-2 divide-y divide-gray-200 border-y border-gray-200">
          {managers.map((manager) => (
            <li
              key={manager.id}
              className="flex items-center justify-between gap-2 py-3"
            >
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-gray-900">
                  {manager.name}
                </p>
                <p className="truncate text-xs text-gray-500">
                  {manager.email}
                </p>
              </div>
              <Button
                style="secondary"
                size="sm"
                loading={isRemoving}
                onClick={() => handleRemoveManager(manager.id)}
              >
                Remove
              </Button>
            </li>
          ))}
        </ul>
      ) : null}

      <form
        onSubmit={handleAddManager}
        className="mt-4 flex grid-cols-3 flex-col gap-2 sm:grid"
      >
        <Input
          name="email"
          label="Email"
          type="email"
          placeholder="Manager’s email"
          required
          hideLabel
          value={data.email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setData("email", e.target.value)
          }
          error={errors?.email}
          className="col-span-2"
        />
        <Button type="submit" style="secondary" loading={processing}>
          Add manager
        </Button>
      </form>
    </div>
  )
}

export default PromotionManagers
